import { ErrorHandler, inject, Injectable } from '@angular/core';
import { LogsService } from './logs.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logs = inject(LogsService);

  handleError(error: unknown): void {
    // Forward the original value: LogsService extracts the stack from a real
    // `Error` (Error Reporting groups occurrences from it) and synthesizes one otherwise.
    const message = error instanceof Error ? error.message : String(error);
    this.logs.error('ErrorHandler', message, error);

    // Preserve default console behavior for dev
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
